import { render } from "./checkbox_captcha.vue?vue&type=template&id=541fa1a3"
import script from "./checkbox_captcha.vue?vue&type=script&lang=js"
export * from "./checkbox_captcha.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__